/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonVariants, buttonVariants } from '../button/button.component';

@Component({
  selector: 'ods-routing-button',
  imports: [CommonModule, RouterLink],
  host: { class: 'block w-fit' },
  template: `<a [routerLink]="routerPath" [attr.data-test-id]="dataTestId" [ngClass]="buttonVariants({ size, variant, spacing })">
    <ng-content select="[icon]" />
    @if (text) {
      <p class="grow text-center">{{ text }}</p>
    }
  </a>`,
})
export class RoutingButtonComponent {
  @Input() linkPath: string;
  @Input() text: string;
  @Input() dataTestId: string;
  @Input() isRelativePath: boolean = false;
  @Input() variant: ButtonVariants['variant'];
  @Input() size: ButtonVariants['size'];
  @Input() spacing: ButtonVariants['spacing'];

  public readonly buttonVariants = buttonVariants;

  get routerPath(): string {
    return this.isRelativePath ? this.linkPath : `/${this.linkPath}`;
  }
}
